import { render, staticRenderFns } from "./kl.vue?vue&type=template&id=3655d657"
import script from "./kl.vue?vue&type=script&lang=js"
export * from "./kl.vue?vue&type=script&lang=js"
import style0 from "./kl.vue?vue&type=style&index=0&id=3655d657&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports